export class AdminAuthService {
  logout(): void {
    // 관리자 토큰 및 관련 데이터 제거
    localStorage.removeItem("adminAccessToken");
    localStorage.removeItem("adminUserInfo");
    // 관리자 로그인 페이지로 리다이렉트
    window.location.href = "/admin/auth";
  }
}

export const adminAuthService = new AdminAuthService();
